module.exports = __webpack_public_path__ + "img/10.cc557b98.jpg";